// import api from '@/services/api';
import { make } from 'vuex-pathify';
import Vue from 'vue';

const state = {
  offers: [],
};

const mutations = {
  ...make.mutations(state),
  DELETE_OFFER(state, offerId) {
    Vue.set(
      state,
      'offers',
      state.offers.filter(offer => offer.id !== offerId)
    );
  },
  DELETE_PROJECT(state, projectId) {
    state.offers.forEach(offer => {
      if (offer.projects) {
        offer.projects = offer.projects.filter(project => project.id !== projectId);
      }
    });
  },
};

const actions = {
  async getOffers({ commit }) {
    // const r = await api.get('v2/offers');
    const r = {
      data: {
        data: [
          {
            id: 1,
            name: 'T0135, Jastrząb-Blizanów, tereny inwestycyjne nr 31',
            description: '',
            date: '2025-05-29T12:01:18.191',
            url: 'https://www.google.com/',
            projects: [
              {
                id: 1,
                name: 'Jastrząb',
                status: 'Nowy',
                description: 'mazowieckie, powiat szydłowiecki',
                measure: 5.28,
                price: '2 mln',
              },
              {
                id: 2,
                name: 'Blizanów',
                status: 'Nowy',
                description: 'wielkopolskie, powiat kaliski',
                measure: 8.54,
                price: '1.8 mln',
              },
            ],
          },
          {
            id: 36,
            name: 'T0136, Jastrząb-Blizanów, tereny inwestycyjne nr 32',
            description:
              'Asserts businesses slipstream company discussions here revision reality. Synergize or / strategic to engagement rehydrate moments socialize. \n Backwards production be reach call read journey shark. ',
            date: '2025-05-28T12:02:18.191',
            url: 'https://www.google.com/',
            projects: [
              {
                id: 3,
                name: 'Project C',
                status: 'Nowy',
                description: 'Description for Project C',
                measure: 5,
                price: '1 mln',
              },
              {
                id: 4,
                name: 'Project D',
                status: 'Nowy',
                description: 'Description for Project D',
                measure: 0.25,
                price: '0.5 mln',
              },
            ],
          },
          {
            id: 33,
            name: 'T033, Jastrząb-Blizanów, tereny inwestycyjne nr 33',
            description: 'For those who come after.',
            date: '2025-04-24:01:18.191',
            url: 'https://www.google.com/',
            projects: [],
          },
        ],
      },
    };
    commit('SET_OFFERS', r.data.data);
  },
  async deleteOffer({ commit }, offerId) {
    commit('DELETE_OFFER', offerId);
  },
  async deleteProject({ commit }, projectId) {
    commit('DELETE_PROJECT', projectId);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
